module.exports = __webpack_public_path__ + "img/2.8cf72443.png";